import { ToastOptionType } from './toast-service.interface';

export enum ToastType {
    PAYMENT_CREATE_ERROR = 'PAYMENT_CREATE_ERROR',
    SUBSCRIPTION_ADD_PRODUCT_ERROR = 'SUBSCRIPTION_ADD_PRODUCT_ERROR',
    ADJUST_QUANTITY_ERROR = 'ADJUST_QUANTITY_ERROR',
    CANCEL_SUBSCRIPTION_ERROR = 'CANCEL_SUBSCRIPTION_ERROR',
    ADD_PAYMENT_METHOD_CREATE_ERROR = 'ADD_PAYMENT_METHOD_CREATE_ERROR',
    ADD_PAYMENT_METHOD_CREATE_SUCCESS = 'ADD_PAYMENT_METHOD_CREATE_SUCCESS',
    ADD_PRODUCT_ERROR = 'ADD_PRODUCT_ERROR',
    ADD_TEMPORARY_LICENSE_ERROR = 'ADD_TEMPORARY_LICENSE_ERROR',
    CANCEL_TEMPORARY_LICENSE_ERROR = 'CANCEL_TEMPORARY_LICENSE_ERROR',
    DOWNLOAD_BILLING_DOCUMENT_ERROR = 'DOWNLOAD_BILLING_DOCUMENT_ERROR',
    CANCEL_ALL_SUBSCRIPTIONS_ERROR = 'CANCEL_ALL_SUBSCRIPTIONS_ERROR',
}

export const toastConfig: Record<
    ToastType,
    {
        translationKey: string;
        options: {
            type: ToastOptionType;
        };
    }
> = {
    [ToastType.PAYMENT_CREATE_ERROR]: {
        translationKey: '',
        options: {
            type: 'error',
        },
    },
    [ToastType.SUBSCRIPTION_ADD_PRODUCT_ERROR]: {
        translationKey: 'subscription.add_product.error.toast',
        options: {
            type: 'error',
        },
    },
    [ToastType.ADJUST_QUANTITY_ERROR]: {
        translationKey: 'subscription.adjust_quantity.error.toast',
        options: {
            type: 'error',
        },
    },
    [ToastType.CANCEL_SUBSCRIPTION_ERROR]: {
        translationKey: 'subscription.cancel_subscription.error.toast',
        options: {
            type: 'error',
        },
    },
    [ToastType.ADD_PAYMENT_METHOD_CREATE_ERROR]: {
        translationKey: 'billing.payment.payment_method_create_error_msg',
        options: {
            type: 'error',
        },
    },
    [ToastType.ADD_PAYMENT_METHOD_CREATE_SUCCESS]: {
        translationKey: 'billing.payment.payment_method_create_success_msg',
        options: {
            type: 'success',
        },
    },
    [ToastType.ADD_PRODUCT_ERROR]: {
        translationKey: 'subscription.add_product.error.toast',
        options: {
            type: 'error',
        },
    },
    [ToastType.ADD_TEMPORARY_LICENSE_ERROR]: {
        translationKey: 'subscription.add_temporary_license.error.toast',
        options: {
            type: 'error',
        },
    },
    [ToastType.CANCEL_TEMPORARY_LICENSE_ERROR]: {
        translationKey: 'subscription.cancel_temporary_license.error.toast',
        options: {
            type: 'error',
        },
    },
    [ToastType.DOWNLOAD_BILLING_DOCUMENT_ERROR]: {
        translationKey: 'billing.download_billing_document.error',
        options: {
            type: 'error',
        },
    },
    [ToastType.CANCEL_ALL_SUBSCRIPTIONS_ERROR]: {
        translationKey: 'subscription.cancel_all_subscriptions.error.toast',
        options: {
            type: 'error',
        },
    },
};
